export interface HeroStateType {
  ready: boolean;
  rotation: number;
  activeSkin: 0 | 1;
  loadProgress: number;
  assetsReady: boolean;
  introVisible: boolean;
  introDismissed: boolean;
}

export const HeroState: HeroStateType = $state({
  ready: false,
  rotation: 0,
  activeSkin: 0,
  loadProgress: 0,
  assetsReady: false,
  introVisible: true,
  introDismissed: false,
});
